export default __webpack_public_path__ + "static/NatalieK-091267a2803a4deb02d61fa4d38a5a1f.png";